module.exports = __webpack_public_path__ + "media/images/sites/health/f-personalizacao-cb35182896c8ae05032742322e29d696.jpg";